// function displayVariantImages(variant){
//     let options;
//     if(variant.options){
//         options = variant.options;
//     }else{
//         options = variant;
//     }
    
//     let productGallery = document.querySelector('product-media-variants[data-layout="two"]');
//     if(productGallery){
//         let productImages = productGallery.querySelectorAll('.product-media--root');
//     }
    

//     if(productGallery){
//         productImages.forEach((img)=>{
//             let alt = img.getAttribute('data-variant-title');
//             if(options.includes(alt)){
//                 img.style.display = 'block';
//             }else{
//                 img.style.display = 'none';
//             }
//         })

//         productGallery.setMasonryLayout();
//     }

//     console.log('Display', variant);
// }


// document.querySelector('DOMContentLoaded',()=>{

// })



function displayVariantImages(variant){
    // An unavailable option combination has no resolved variant yet.
    // Keep the current gallery until a valid selection is available.
    const options = Array.isArray(variant) ? variant : variant?.options;
    if (!Array.isArray(options)) return;
    
    let productGallery = document.querySelector('product-media-variants[data-layout="thumbnails"]');
    let productThumbImages = [];
    if(productGallery){
        productThumbImages = productGallery.querySelectorAll('product-thumbs-root .product-media--thumb');
    }

    let productGalleryMobile = document.querySelector('.product-mobile-slider');
    let productThumbImagesMobile = [];
    if(productGalleryMobile){
        productThumbImagesMobile = productGalleryMobile.querySelectorAll('.swiper-slide');
    }
    

    if(productGallery){
        productThumbImages.forEach((img)=>{
            let alt = img.getAttribute('data-variant-title');
           
            if(options.includes(alt) || alt == '' || alt == 'show'){
                img.style.display = 'block';
            }else{
                img.style.display = 'none';
            }
        })

        // Some variants reference a photograph of a different gold color.
        // Filtering the dots alone must not leave that excluded photo on stage.
        const thumbs = Array.from(productThumbImages);
        const activeThumb = thumbs.find(thumb => thumb.getAttribute('data-active') === 'true');
        if (activeThumb && activeThumb.style.display === 'none') {
            const matching = thumbs.find(thumb => options.includes(thumb.getAttribute('data-variant-title')));
            const fallback = thumbs.find(thumb => thumb.style.display !== 'none');
            (matching || fallback)?.click();
        }
    }

    if(productGalleryMobile){
        let swiperObject = productGalleryMobile.swiper;
        productThumbImagesMobile.forEach((img)=>{
            const media = img.querySelector('.product-media--root');
            if (!media) return;
            let alt = media.getAttribute('data-variant-title');
           
            if(options.includes(alt) || !alt || alt == 'show'){
                img.style.display = 'block';
                img.classList.remove('hidden-slide');
            }else{
                img.style.display = 'none';
                img.classList.add('hidden-slide');
            }
        })
        if(swiperObject){
            const swiperWrapper = swiperObject.wrapperEl;
            const slides = Array.from(swiperObject.slides);
          
            const slidesWithoutVariant = slides.filter(slide => {
              const media = slide.querySelector('.product-media--root');
              return media && !media.getAttribute('data-variant-title');
            });
          
            const slidesWithVariant = slides.filter(slide => {
              const media = slide.querySelector('.product-media--root');
              return !media || media.getAttribute('data-variant-title');
            });
          
            swiperWrapper.innerHTML = '';
            [...slidesWithVariant, ...slidesWithoutVariant].forEach(slide => {
              swiperWrapper.appendChild(slide);
            });
          
            const slidesCount = swiperObject.slides.filter(
              slide => !slide.classList.contains('hidden-slide')
            ).length;

            swiperObject.params.centeredSlides = slidesCount === 1;
            swiperObject.updateSlides();
            swiperObject.slideTo(0);
            swiperObject.update();
        }

        if(window.innerWidth <= 767){
            window.scrollTo({top: 0, behavior: 'smooth'});
        }
        
    }

}







class ProductMobileSlider extends HTMLElement {
    constructor() {
      super();
      this.sliderElem = this.querySelector('.product-mobile-slider');
      this.swiper = null;

      this.init();
    }
  
    init(){
        this.swiper = new Swiper(this.sliderElem, {
            loop: false,
            slidesPerView: 1,
            spaceBetween: 16,
            slidesOffsetAfter: 0,
            pagination: {
              el: '.swiper-pagination',
            },
            zoom: true
        });
    }
  }
  
  customElements.define("custom-mobile-slider", ProductMobileSlider);
  
